// The questions another surface staged with a chat's context (the case an
// investigation opened on), offered above the composer until the first
// question goes out: a busy line while they are written, then one button per
// question. A pick fills the composer to edit or send; nothing is sent.
export default function ChatStarterQuestions({ pendingContext = null, busy = false, onPick }) {
    const pending = Boolean(pendingContext?.startersPending);
    const starters = Array.isArray(pendingContext?.starters) ? pendingContext.starters : [];
    if (!pendingContext || busy || (!pending && !starters.length)) return null;
    return (
        <div data-chat-starters="" aria-busy={pending ? "true" : undefined} className="mt-[8px] flex flex-wrap gap-[6px]">
            {pending ? (
                <span className="text-[11px] leading-[1.3] text-[color:var(--muted-soft)]">Writing starter questions for this case{"…"}</span>
            ) : starters.map((q) => (
                <button
                    key={q}
                    type="button"
                    data-chat-starter=""
                    onClick={() => onPick?.(q)}
                    className="cursor-pointer rounded-[2px] border border-[color:var(--line)] bg-transparent px-[8px] py-[3px] text-left text-[11px] leading-[1.3] text-[color:var(--muted)] transition-colors hover:border-[color:var(--line-strong)] hover:text-[color:var(--ink)]"
                >
                    {q}
                </button>
            ))}
        </div>
    );
}
